<template>
  <div :class="{ 'showcase-ru': lang === 'ru' }" class="showcase" id="showcase">
    <div class="content">
      <h1 :class="{ 'font-weight-bold': lang === 'ru' }" class="title">
        <template v-if="lang === 'en'">Choose your set</template>
        <template v-else>Выберите набор материалов</template>
      </h1>
      <div class="showcase__wrapper">
        <div
          v-for="(item, index) in list[lang]"
          :class="{
            'showcase__item--basic': item.id === 'basic',
            'showcase__item--plus': item.id === 'plus',
            'showcase__item--pro': item.id === 'pro',
            'showcase__item--max': item.id === 'max',
          }"
          :key="index"
          class="showcase__item">
          <span class="showcase__title" v-text="item.title" />

          <swiper

            :loop="true"
            :modules="modules"
            :pagination="{
              clickable: true,
            }"
            :slides-per-view="1"
            :speed="750">
            <swiper-slide>
              <div v-for="(item_before, index) in item.before" :key="index" class="showcase__before">
                <div class="showcase__image showcase__image--before">
                  <img :alt="item.title" :src="require(`@/assets/img/${item_before.image}`)" />

                  <div class="showcase__types">
                    <span v-for="(item, index) in item_before.type" :class="{ 'showcase__type--full': item.full_width }" :key="index" class="showcase__type" v-text="item.title" />
                  </div>
                </div>
              </div>
            </swiper-slide>

            <swiper-slide>
              <div class="showcase__after">
                <div v-for="(item, index) in item.after" :key="index" class="showcase__image showcase__image--after">
                  <img :alt="item.type" :src="require(`@/assets/img/${item.image}`)" />

                  <span v-if="item.type" :class="{ 'showcase__type--single': item.single }" class="showcase__type showcase__type--after" v-text="item.type" />

                  <span v-if="item.logo" class="showcase__type showcase__type--after showcase__type--logo">
                    <template v-if="lang === 'en'">logo</template>
                    <template v-else>логотип</template>
                  </span>
                </div>
              </div>
            </swiper-slide>
          </swiper>

          <div class="showcase__info">
            <div class="showcase__info-wrapper">
              <div class="showcase__options">
                <span
                  v-for="(item, index) in item.option"
                  :class="{
                    'showcase__option--yellow-border': item.yellow_border,
                    'showcase__option--yellow-color': item.yellow_color,
                    'showcase__option--ru': lang === 'ru',
                    'showcase__option--column': item.column,
                  }"
                  :key="index"
                  class="showcase__option"
                  v-text="item.title"/>
              </div>

              <span class="showcase__price">
                <template v-if="lang === 'ru' && item.price && item.price.includes(' ')">
                  <span class="showcase__price" v-text="item.price"></span>
                  <span class="showcase__price--currency">₽</span>
                </template>
                <template v-else>
                  <span class="showcase__price" v-text="item.price"></span>
                </template>
              </span>
            </div>
          </div>

          <div :class="{ hidden: lang === 'ru' }" class="showcase__button-wrapper">
            <button
              :class="{
                'btn-order-basic btn-service-place-basic': item.id === 'basic',
                'btn-order-plus btn-service-place-plus': item.id === 'plus',
                'btn-order-pro btn-service-place-pro': item.id === 'pro',
                'btn-order-render btn-service-place-render': item.id === 'render',
                'btn-order-max btn-service-place-max': item.id === 'max',
              }"
              class="showcase__button"
              v-text="item.button"
              @click="handleButtonClick(item)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Autoplay, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper-bundle.css';
import { triggeringYandexMetric } from '@/assets/js/yandex-metrics';
import config from '@/config';

export default {
  name: 'Showcase',

  components: {
    Swiper,
    SwiperSlide,
  },

  props: {
    lang: {
      type: String,
      required: true,
    },
    openPreOrderForm: {
      default: () => null,
      type: Function,
    },
    openOrderModal: {
      default: () => null,
      type: Function,
    },
  },

  setup() {
    return {
      modules: [Autoplay, Pagination],
    };
  },

  data: () => ({
    tariffs: {
      basic: 1,
      plus: 2,
      pro: 3,
      render: 4,
      max: 6,
    },
    list: {
      en: [
        {
          after: [
            {
              image: 'showcase/2d.jpg',
              type: '2D',
            },
            {
              image: 'showcase/3d.jpg',
              type: '3D',
            },
          ],
          before: [
            {
              image: 'showcase/3d.jpg',
              type: [
                {
                  title: '2D',
                },
                {
                  title: '3D',
                },
              ],
            },
          ],
          button: 'Place an order',
          id: 'basic',
          option: [
            {
              title: '2D floor plan',
            },
            {
              title: '3D floor plan',
            },
          ],
          price: '$25',
          title: 'Basic set',
        },
        {
          after: [
            {
              image: 'showcase/2d.jpg',
              type: '2D',
            },
            {
              image: 'showcase/360.webp',
              type: '360 tour',
            },
            {
              image: 'showcase/3d.jpg',
              type: '3D',
            },
          ],
          before: [
            {
              image: 'showcase/plus.webp',
              type: [
                {
                  title: '2D',
                },
                {
                  title: '3D',
                },
                {
                  full_width: true,
                  title: '360 tour',
                },
              ],
            },
          ],
          button: 'Place an order',
          id: 'plus',
          option: [
            {
              title: '2D floor plan',
            },
            {
              title: '3D floor plan',
            },
            {
              title: 'Virtual tour',
              yellow_border: true,
            },
          ],
          price: '$45',
          title: 'Plus set',
        },
        {
          autoplay: {
            delay: 7000,
            disableOnInteraction: false,
          },
          after: [
            {
              image: 'showcase/2d.jpg',
              type: '2D',
            },
            {
              image: 'showcase/360.webp',
              type: '360 tour',
              logo: true,
            },
            {
              image: 'showcase/3d.jpg',
              type: '3D',
            },
          ],
          before: [
            {
              image: 'showcase/pro.webp',
              type: [
                {
                  title: '2D',
                },
                {
                  title: '3D',
                },
                {
                  title: 'logo',
                },
                {
                  title: '360 tour',
                },
              ],
            },
          ],
          button: 'Place an order',
          id: 'pro',
          option: [
            {
              title: '2D floor plan',
            },
            {
              title: '3D floor plan',
            },
            {
              title: 'Virtual tour',
              yellow_border: true,
            },
            {
              title: 'Branding',
              yellow_border: true,
              yellow_color: true,
            },
          ],
          price: '$49',
          title: 'Pro set',
        },
        {
          after: [
            {
              image: 'showcase/2d.jpg',
              type: '2D',
            },
            {
              image: 'showcase/360.webp',
              type: '360 tour',
            },
            {
              image: 'showcase/3d.jpg',
              type: '3D',
            },
            {
              image: 'showcase/renders-1.webp',
              type: 'renders',
            },
          ],
          before: [
            {
              image: 'showcase/render.webp',
              type: [
                {
                  title: '2D',
                },
                {
                  title: '3D',
                },
                {
                  full_width: true,
                  title: 'renders',
                },
                {
                  full_width: true,
                  title: '360 tour',
                },
              ],
            },
          ],
          button: 'Place an order',
          id: 'render',
          option: [
            {
              title: '2D floor plan',
            },
            {
              title: '3D floor plan',
            },
            {
              title: 'Virtual tour',
              yellow_border: true,
            },
            {
              title: 'High quality',
              yellow_border: true,
            },
            {
              title: 'Renderings',
              yellow_border: true,
            },
          ],
          price: '$49',
          title: 'Render set',
        },
        {
          after: [
            {
              image: 'showcase/2d.jpg',
              type: '2D',
            },
            {
              image: 'showcase/360.webp',
              type: '360 tour + logo',
            },
            {
              image: 'showcase/3d.jpg',
              type: '3D',
            },
            {
              image: 'showcase/renders-1.webp',
              type: 'renders',
            },
          ],
          before: [
            {
              image: 'showcase/max.webp',
              type: [
                {
                  title: '2D',
                },
                {
                  title: '3D',
                },
                {
                  title: 'renders',
                },
                {
                  title: 'logo',
                },
                {
                  full_width: true,
                  title: '360 tour',
                },
              ],
            },
          ],
          button: 'Place an order',
          id: 'max',
          option: [
            {
              title: '2D floor plan',
            },
            {
              title: '3D floor plan',
            },
            {
              title: 'Virtual tour',
              yellow_border: true,
            },
            {
              title: 'High quality',
              yellow_border: true,
            },
            {
              title: 'Renderings',
              yellow_border: true,
            },
            {
              title: 'Branding',
              yellow_border: true,
              yellow_color: true,
            },
          ],
          price: '$69',
          title: 'Max set',
        },
      ],
      ru: [
        {
          after: [
            {
              image: 'showcase/2d.jpg',
              type: '2D',
            },
            {
              image: 'showcase/3d.jpg',
              type: '3D',
            },
          ],
          before: [
            {
              image: 'showcase/3d.jpg',
              type: [
                {
                  title: '2D',
                },
                {
                  title: '3D',
                },
              ],
            },
          ],
          button: 'Заказать',
          id: 'basic',
          option: [
            {
              title: '2D планировка',
            },
            {
              title: '3D планировка',
            },
          ],
          price: '2 450',
          title: 'Basic',
        },
        {
          after: [
            {
              image: 'showcase/2d.jpg',
              type: '2D',
            },
            {
              image: 'showcase/360.webp',
              type: '360 тур',
            },
            {
              image: 'showcase/3d.jpg',
              type: '3D',
            },
          ],
          before: [
            {
              image: 'showcase/plus.webp',
              type: [
                {
                  title: '2D',
                },
                {
                  title: '3D',
                },
                {
                  full_width: true,
                  title: '360 тур',
                },
              ],
            },
          ],
          button: 'Заказать',
          id: 'plus',
          option: [
            {
              title: '2D планировка',
            },
            {
              title: '3D планировка',
            },
            {
              title: 'Виртуальный тур',
              yellow_border: true,
            },
          ],
          price: '4 450',
          title: 'Plus',
        },
        {
          autoplay: {
            delay: 7000,
            disableOnInteraction: false,
          },
          after: [
            {
              image: 'showcase/2d.jpg',
              type: '2D',
            },
            {
              image: 'showcase/360.webp',
              type: '360 тур',
              logo: true,
            },
            {
              image: 'showcase/3d.jpg',
              type: '3D',
            },
          ],
          before: [
            {
              image: 'showcase/pro.webp',
              type: [
                {
                  title: '2D',
                },
                {
                  title: '3D',
                },
                {
                  title: 'логотип',
                },
                {
                  title: '360 тур',
                },
              ],
            },
          ],
          button: 'Заказать',
          id: 'pro',
          option: [
            {
              title: '2D планировка',
            },
            {
              title: '3D планировка',
            },
            {
              title: 'Виртуальный тур',
              yellow_border: true,
            },
            {
              title: 'Брендинг',
              yellow_border: true,
              yellow_color: true,
            },
          ],
          price: '4 900',
          title: 'Pro',
        },
        {
          after: [
            {
              image: 'showcase/2d.jpg',
              type: '2D',
            },
            {
              image: 'showcase/360.webp',
            },
            {
              image: 'showcase/3d.jpg',
              type: '3D',
            },
            {
              image: 'showcase/renders-1.webp',
              single: true,
              type: 'рендеры',
            },
          ],
          before: [
            {
              image: 'showcase/render.webp',
              type: [
                {
                  title: '2D',
                },
                {
                  title: '3D',
                },
                {
                  full_width: true,
                  title: 'рендеры',
                },
              ],
            },
          ],
          button: 'Заказать',
          id: 'render',
          option: [
            {
              title: '2D планировка',
            },
            {
              title: '3D планировка',
            },
            {
              title: 'Рендеры',
              yellow_border: true,
            },
          ],
          price: '4 900',
          title: 'Render',
        },
        {
          after: [
            {
              image: 'showcase/2d.jpg',
              type: '2D',
            },
            {
              image: 'showcase/360.webp',
              type: '360 тур + логотип',
            },
            {
              image: 'showcase/3d.jpg',
              type: '3D',
            },
            {
              image: 'showcase/renders-1.webp',
              type: 'рендеры',
            },
          ],
          before: [
            {
              image: 'showcase/max.webp',
              type: [
                {
                  title: '2D',
                },
                {
                  title: '3D',
                },
                {
                  title: 'логотип',
                },
                {
                  title: 'рендеры',
                },
                {
                  full_width: true,
                  title: '360 тур',
                },
              ],
            },
          ],
          button: 'Заказать',
          id: 'max',
          option: [
            {
              title: '2D планировка',
            },
            {
              title: '3D планировка',
            },
            {
              title: 'Виртуальный тур',
              yellow_border: true,
            },
            {
              column: true,
              title: 'Рендеры',
              yellow_border: true,
            },
            {
              column: true,
              title: 'Брендинг',
              yellow_border: true,
            },
          ],
          price: '6 900',
          title: 'Max',
        },
      ],
    },
  }),
  methods: {
    async handleButtonClick(item) {
      try {
        if (item.action) {
          await this.openPreOrderForm();
        } else {
          await this.openOrderModal(this.tariffs[item.id]);
        }

        if (config.appEnv === 'production') {
          triggeringYandexMetric.submitNewUploadForm();
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
